import { ChangeDetectionStrategy, Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FiDialogsContentBase } from '@fi-shared/fi-dialogs/fi-dialogs-content-base';
import { FiTranslationService } from '@fi-app/fi-translation/fi-translation.service';
import { BehaviorSubject } from 'rxjs';

interface ITextLabelImportResult {
    ExcelRowsCount: number;
    ExcelLabelsCount: number;
    LabelsToAdd: number;
    LabelsToUpdate: number;
    OverwriteItems: ITextLabelImportItem[];
    ErrorItems: ITextLabelImportItem[];
}

interface ITextLabelImportItem {
    LabelTextId: number;
    Language: string;
    ExistingLabelValue: string;
    NewLabelValue: string;
}

@Component({
    selector: 'fi-import-labels-dialog',
    template: `
        <div class="import-data">
          <div>
            <b>{{ 'translation.text_labels_danger_operation' | fiAppText }}</b>
          </div>
          <div>
            {{ 'translation.keep_existing_text_ids' | fiAppText
            }}<input class="text-ids-input" [(ngModel)]="textIdsToKeep" />
          </div>
          <div>
            {{ 'translation.text_ids_to_overwrite' | fiAppText
            }}<input class="text-ids-input" [(ngModel)]="textIdsToOverwrite" />
          </div>
          <div>
            <input type="file" accept=".xlsx" (change)="onExcelFileSelected($event)" />
          </div>
        </div>
        @if (importResult$ | async; as importResult) {
          <div class="import-results">
            @if (importResult.ErrorItems.length) {
              <div>Update failed</div>
            }
            <div>{{ importResult.ExcelRowsCount }} rows found</div>
            <div>{{ importResult.ExcelLabelsCount }} text values found</div>
            <div>{{ importResult.LabelsToAdd }} labels to add</div>
            <div>{{ importResult.LabelsToUpdate }} labels to update</div>
            @for (item of importResult.ErrorItems; track item) {
              <div>
                <br />
                <div>
                  <b>TextId {{ item.LabelTextId }}, {{ item.Language }}</b>
                  <!--&nbsp;&nbsp;<input type="checkbox" /> Keep existing
                  &nbsp;&nbsp;<input type="checkbox" /> Overwrite-->
                </div>
                <div><span class="import-result-label">existing:</span> '{{ item.ExistingLabelValue }}'</div>
                <div><span class="import-result-label">new:</span> '{{ item.NewLabelValue }}'</div>
              </div>
            }
            @for (item of importResult.OverwriteItems; track item) {
              <div>
                <br />
                <div>
                  <b>TextId to overwrite {{ item.LabelTextId }}, {{ item.Language }}</b>
                </div>
                <div><span class="import-result-label">existing:</span> '{{ item.ExistingLabelValue }}'</div>
                <div><span class="import-result-label">new:</span> '{{ item.NewLabelValue }}'</div>
              </div>
            }
          </div>
        }
        `,
    styleUrls: ['./fi-import-labels-dialog.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-import-labels-dialog' },
    standalone: false,
})
export class FiImportLabelsDialogComponent extends FiDialogsContentBase<void, any> implements OnInit {
    textIdsToKeep: string;
    textIdsToOverwrite: string;
    private translationService: FiTranslationService;
    private formFile: File;
    importResult$ = new BehaviorSubject<ITextLabelImportResult>(undefined);

    ngOnInit(): void {
        this.translationService = this.injector.get(FiTranslationService);
    }

    override getYesButtonClickPromise(): Promise<{ canClose: boolean }> {
        return new Promise<{ canClose: boolean }>((resolve, reject) => {
            this.translationService
                .importTextLabelsFromExcel(this.formFile, this.textIdsToKeep, this.textIdsToOverwrite)
                .then((response) => {
                    this.importResult$.next(response);
                    resolve({ canClose: false });
                }, reject);
        });
    }

    override isYesButtonDisabled(): boolean {
        return !this.formFile;
    }

    onExcelFileSelected($event) {
        if ($event.target && $event.target.files.length) {
            this.formFile = $event.target.files[0];
        } else {
            this.formFile = undefined;
        }
    }
}
